import { GlobalNamespace } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "./window.service";
import * as i2 from "@angular/common";
var GlobalService = /** @class */ (function () {
    function GlobalService(_window, _document) {
        this._window = _window;
        this._document = _document;
        this.ns = this.namespace;
        this.key = GlobalNamespace.namespace;
    }
    Object.defineProperty(GlobalService.prototype, "document", {
        get: function () {
            return this._document;
        },
        enumerable: true,
        configurable: true
    });
    GlobalService.prototype.namespace = function () {
        var global = GlobalNamespace;
        if (global.hasOwnProperty('namespace')) {
            return this._window[global.namespace];
        }
        return new Object();
    };
    GlobalService.prototype.find = function (key) {
        if (!key) {
            return this.namespace();
        }
        /* array of keys */
        var ark = key.split(':');
        /* search results to return */
        var doc = this.ns();
        if (ark.length) {
            ark.forEach(function (el) {
                doc = (doc[el] === undefined) ? '' : doc[el];
            });
        }
        return doc;
    };
    GlobalService.ngInjectableDef = i0.defineInjectable({ factory: function GlobalService_Factory() { return new GlobalService(i0.inject(i1.WINDOW), i0.inject(i2.DOCUMENT)); }, token: GlobalService, providedIn: "root" });
    return GlobalService;
}());
export { GlobalService };
